import { createFileRoute } from "@tanstack/react-router";

import { CommsSettings } from "../components/settings/CommsSettings";

export const Route = createFileRoute("/settings/comms")({
  component: CommsSettings,
});
